import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceFieldAPI } from '@core/typings/api/reference-fields.typing';
import { FormFieldHelperService } from '@features/form-fields/services/form-field-helper.service';

@Pipe({
  name: 'gcDataSetCollectionData'
})
export class DataSetCollectionDataPipe implements PipeTransform {
  constructor (
    private formFieldHelperService: FormFieldHelperService
  ) { }

  transform (data: number, collectionType: ReferenceFieldAPI.DataSetCollectionType) {
    let returnVal: number|string|boolean;
    switch (collectionType) {
      case ReferenceFieldAPI.DataSetCollectionType.Number:
        returnVal = data ?? 0;
        break;
      case ReferenceFieldAPI.DataSetCollectionType.Percent:
        returnVal = (data ?? 0) + '%';
        break;
      default:
      case ReferenceFieldAPI.DataSetCollectionType.YesOrNo:
        returnVal = this.formFieldHelperService.convertNumberToCheckboxValue(data);
        break;
    }

    return returnVal;
  }
}
